export default "const Earth = require(\"earth\");\n\nnew Earth({\n  drawShape: true\n});\n";